export default function Hero() {
  const openVoiceAgent = () => {
    const btn = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (btn) btn.click();
  };

  const scrollToDemo = () => {
    const element = document.getElementById('demo-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0a0e27]">
      {/* Imagen de fondo futurista */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/1a62d479ea6bd5856073579187b5ee28/ce1d7a5da9d13c227cc5aaa99d1bc682.png"
          alt="Futuristic background"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlay oscuro para contraste */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/75 z-10"></div>
      {/* Overlay de color para mantener la paleta cyan/purple */}
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-900/30 via-transparent to-purple-900/30 z-10"></div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 text-center w-full py-16 sm:py-20">
        <div className="mb-8 sm:mb-12 animate-fade-in">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white mb-6 sm:mb-8 leading-tight px-2">
            Escucha cómo sonaría un{' '}
            <span className="bg-gradient-to-r from-cyan-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent">
              Agente Inteligente de Voz
            </span>
            <br />
            en tu negocio.
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed px-4">
            Atiende clientes 24/7, filtra prospectos y agenda citas automáticamente.
          </p>
          <p className="text-sm sm:text-base md:text-lg text-gray-400 max-w-3xl mx-auto leading-relaxed px-4 mt-4">
            Habla con tus clientes en su idioma. Nuestro agente ya atiende en{' '}
            <span className="text-white font-semibold">🇪🇸 Español</span>,{' '}
            <span className="text-white font-semibold">🇺🇸 English</span>,{' '}
            <span className="text-white font-semibold">🇧🇷 Português</span> e{' '}
            <span className="text-white font-semibold">🇮🇹 Italiano</span>
            <span className="text-gray-400">… y puede adaptarse a más de </span>
            <span className="text-cyan-400 font-bold">120 idiomas</span>.
          </p>
        </div>

        <div className="max-w-[280px] sm:max-w-sm mx-auto mb-12 sm:mb-16 px-4">
          <div className="relative w-full rounded-2xl overflow-hidden shadow-2xl shadow-cyan-500/20 border-2 border-cyan-500/30" style={{ aspectRatio: '9/16' }}>
            <iframe
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/SjStx9JLzvY"
              title="Agente Inteligente de Voz Demo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <div className="mt-12 sm:mt-20 pt-8 sm:pt-12 border-t border-cyan-500/20 px-4">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-4 sm:mb-6">
            ¿Prefieres agendar directamente?
          </h3>
          <p className="text-base sm:text-lg text-gray-300 mb-6 sm:mb-8">
            Reserva aquí tu entrevista estratégica.
          </p>
          <button
            onClick={scrollToDemo}
            className="px-8 sm:px-10 py-3 sm:py-4 border-2 border-cyan-400 text-cyan-400 text-base sm:text-lg font-bold rounded-full hover:bg-cyan-400/10 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="flex items-center gap-2 sm:gap-3">
              <i className="ri-calendar-line text-xl sm:text-2xl"></i>
              Ver Calendario
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
